import { render, staticRenderFns } from "./TipoGarantiaContratoListForm.vue?vue&type=template&id=2886ae84"
import script from "./TipoGarantiaContratoListForm.vue?vue&type=script&lang=js"
export * from "./TipoGarantiaContratoListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports